import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"

export const state = () => ({
  lang: process.env.VUE_APP_I18N_LOCALE,
  isContestClosed: false,
  appDomain: null,
  destinations: [],
  selectedDestination: null,
  sentInvitations: {},
  user: {},
  utms: {
    utm_source: "tuangoconcours2026",
    utm_campaign: "Voyage_de_reve_2026",
    utm_medium: "ContestPage",
    utm_content: null,
    utm_term: null
  }
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
